import Axios from "axios";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond/dist/filepond.min.css";
import { useContext, useEffect, useState } from "react";
import { registerPlugin } from "react-filepond";
import { useHistory } from "react-router";
import Context from "../Context";
import Layout from "../Layout/Layout";
import Constant, { statusFailure } from "./Constant";
import {
  DeleteStory,
  createPaymentRequest,
  createStory,
  getDataById,
  getStoryCategories,
  getContestDataById,
  getThumbnailsFromAI,
  uploadThumbImage,
  getStoryCategoriesCopy,
  getLanguages,
  uploadIDCardsImage,
  getProfileDetails,
} from "./utilities/ApiCalls";
import imageCompression from "browser-image-compression";
import {
  authFacebook,
  authGoogle,
  loginUser,
  sendOtpApi,
} from "./utilities/Authentication";
import Logo from "../Images/Logonew.jpeg";

import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import $, { param } from "jquery";
import { useTranslation } from "react-i18next";
import { getTokenDetails } from "./utilities/CommonFunction";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { Check, Cross, Loader, Loader2, Plus } from "lucide-react";
import { Cropper } from "react-cropper";
import { event } from "react-ga";
import { setPageTitle } from "../utils/titleUtils";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom/cjs/react-router-dom";
import i18next from "i18next";
import { CustomLanguageDropdown } from "../Componets/CustomLanguageDropdown";
let val = 1;
let arr = [];

// register if want to preview

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

function StoryWrite(props) {
  const location = useLocation();
  // const constest_id = location.state?.contestId;

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  const query = new URLSearchParams(props.location.search);
  let constest_id = query.get("contestId");
  let language = query.get("language");
  let id = query.get("userId");
  let type = "story";

  const { t } = useTranslation();
  let amount = query.get("amount");

  let token = localStorage.getItem("loginDetails");
  const history = useHistory();
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState("");
  const [documents, setDocuments] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [genBtnStatus, setgenBtnStatus] = useState(false);
  const [imgdata, setImgData] = useState("");
  const [thumblain, setThumblain] = useState(null);
  const { state, dispatch } = useContext(Context);
  const [getImage, setGetImage] = useState(false);
  const [CloseSuccess, setCloseSuccess] = useState(false);
  const [closeError, setCloseError] = useState(false);
  const [storyForm, setStoryForm] = useState({
    name: "",
    thumbnail: "",
    categoryId: ["65b657962e5c1ebb447265c6"],
    description: "",
    document: [],
    duration: "",
    contestId: constest_id,
    languageId: "",
    id: "",
    refId: "",
    idCard: "",
    cityName: "",
    collegeName: "",
    collegeAddress: "",
    isAdultContent: false,
  });

  const [base64Image, setBase64Image] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [btnStatus, setbtnStatus] = useState(false);
  const [images, setImages] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [length, setLength] = useState(1);
  const [retry, setRetry] = useState(0);
  const [contentData, setContentData] = useState({});
  const [image, setImage] = useState(null);
  const [cropData, setCropData] = useState(null);
  const [cropper, setCropper] = useState(null);
  const [idCardImage, setIdCardImage] = useState(null);
  const [idCardBase64, setIdCardBase64] = useState("");
  const [idCardSelectedFile, setIdCardSelectedFile] = useState(null);
  const [idCardCropper, setIdCardCropper] = useState(null);
  const [idCardCropData, setIdCardCropData] = useState(null);
  const [contestdata, setContestdata] = useState({});
  const [payOpen, setPayOpen] = useState(false);

  useEffect(() => {
    // hide second step
    $("#second-step").hide();
    let prams = {};
    if (constest_id) prams.contestType = 1;

    if (constest_id) {
      setStoryForm({
        ...storyForm,
        contestId: constest_id,
      });
    }

    // let prams = { moduleType: 1 };
    getStoryCategories(prams).then((response) => {
      if (response.status !== statusFailure) {
        console.log("response.data-------------->");
        console.log(response);
        setCategories(response.data);
      } else {
        setError(response.message);
        setCloseError(false);
      }
    });
    getLanguages().then((response) => {
      if (response.status !== statusFailure) {
        console.log(response);
        setLanguages(response);
        setStoryForm({ ...storyForm, languageId: response[0]._id });
      } else {
        setError(response.message);
        setCloseError(false);
      }
    });

    getTHumbnail(1);

    if (id && type) {
      prams = { id: id, type: type };
      getDataById(prams).then((data) => {
        if (data.status === Constant.statusSuccess) {
          setContentData(data.data[0]);
          console.log("content data ", contentData);

          // make category active

          if (data.data[0].categoryId.length > 0) {
            let categoryIds = data.data[0].categoryId;
            categoryIds.map((el) => {
              $("#" + el).addClass("active");
            });
          }

          setStoryForm({
            ...storyForm,
            id: id,
            name: data.data[0].name,
            description: data.data[0].description,
            thumbnail: data.data[0].thumbnail,
            duration: data.data[0].duration,
            categoryId: data.data[0].categoryId,
            languageId: data.data[0].languageId,
            contestId: data.data[0].contestId,
            isAdultContent: data.data[0].isAdultContent,
          });
          console.log(storyForm);
        } else {
          setError(data.message);
          setCloseError(false);
        }
      });
    }
  }, []);

  useEffect(() => {
    const fetch = async () => {
      const response = await getContestDataById({ id: constest_id });
      console.log(response.data);
      setContestdata(response.data[0]);
      console.log(contestdata);
    };
    fetch();
  }, []);

  useEffect(() => {
    // let prams = {};
    // if (constest_id) prams.contestType = 1;
    let prams = {};
    if (constest_id) prams.contestType = 1;

    getStoryCategories(prams).then((response) => {
      if (response.status !== statusFailure) {
        console.log("response category----------------->");
        console.log(response);
        setCategories(response.data);
      } else {
        setError(response.message);
        setCloseError(false);
      }
    });
    getLanguages().then((response) => {
      if (response.status !== statusFailure) {
        console.log("response category----------------->");
        console.log(response);
        setLanguages(response);
        setStoryForm({ ...storyForm, languageId: response[0]._id });
      } else {
        setError(response.message);
        setCloseError(false);
      }
    });
  }, []);

  useEffect(() => {
    console.log("stated changed", storyForm);
  }, [storyForm]);

  useEffect(() => {
    const loginDetails = localStorage.getItem("loginDetails");
    console.log("Login details:", loginDetails); // Debug log

    if (!loginDetails || loginDetails === "undefined") {
      setShowLoginPopup(true);
      console.log("Showing login popup - no valid login details found");
    } else {
      setShowLoginPopup(false);
      console.log("User is logged in");
    }
  }, []);

  function onFormChange(e) {
    if (e.target.id === "isAdultContent") {
      console.log(e.target.checked);
      setStoryForm({
        ...storyForm,
        isAdultContent: e.target.checked,
      });
    } else {
      if (e.target.id === "name") {
        let words = e.target.value.split(" ").length;
        if (words > 50) {
          setError("Title should be less then or equal to 5 words.");
          setCloseError(false);
          setbtnStatus(true);
        } else {
          setError("");
          setbtnStatus(false);
        }
      }

      if (e.target.id === "description") {
        let words = e.target.value.split(" ").length;
        // if (words > 5) {
        //   setError("Description should be less then or equal to 5 words.");
        //   setbtnStatus(true);
        // } else {
        //   setError("");
        //   setbtnStatus(false);
        // }
        console.log("contest id");
      }

      setStoryForm({
        ...storyForm,
        [e.target.name]: e.target.value,
      });
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    if (file) {
      try {
        // Define compression options
        const options = {
          maxSizeMB: 2, // Target size in MB
          maxWidthOrHeight: 1024, // Max width or height of the image
          useWebWorker: true, // Use multi-threading for compression
        };

        // Compress the image file
        const compressedFile = await imageCompression(file, options);
        console.log("compressed file", compressedFile);

        // Convert the compressed file to base64
        convertToBase64(compressedFile);

        // Store the compressed file
        setSelectedFile(compressedFile);
      } catch (error) {
        console.error("Error compressing file:", error);
      }
    }

    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    if (files[0] instanceof Blob) {
      const reader = new FileReader();

      reader.onload = () => {
        setImage(reader.result);
      };

      reader.readAsDataURL(files[0]);
    } else {
      console.error("The provided file is not a valid Blob or File.");
    }
  };
  const handleIdCardFileChange = async (e) => {
    const file = e.target.files[0];

    if (file) {
      try {
        const options = {
          maxSizeMB: 2,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        convertIdCardToBase64(compressedFile);
        setIdCardSelectedFile(compressedFile);
      } catch (error) {
        console.error("Error compressing ID card file:", error);
      }

      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      if (files[0] instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          setIdCardImage(reader.result);
        };
        reader.readAsDataURL(files[0]);
      }
    }
  };

  const getCropData = async () => {
    console.log("getCropData", cropper);
    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas({
        width: 1024, // Resize as needed
        height: 1024,
      });

      const base64Data = croppedCanvas.toDataURL("image/jpeg", 0.8); // Compress on canvas
      const blobData = await fetch(base64Data).then((res) => res.blob());

      try {
        const options = {
          maxSizeMB: 2, // Target size in MB
          maxWidthOrHeight: 1024, // Max width or height of the image
          useWebWorker: true, // Use multi-threading for compression
        };

        const compressedBlob = await imageCompression(blobData, options);
        const compressedBase64 = await convertToBase64(compressedBlob);

        setBase64Image(compressedBase64);
        const response = await uploadThumbImage(compressedBase64); // Upload the compressed cropped image
        let form = storyForm;
        form["thumbnail"] = response.location;
      } catch (error) {
        console.error("Error compressing cropped image:", error);
      }
    }
  };
  // In your StoryWrite component

  // Add this to your getCropData function for ID card
  const getIdCardCropData = async () => {
    if (idCardCropper) {
      try {
        const croppedCanvas = idCardCropper.getCroppedCanvas({
          width: 1024,
          height: 1024,
        });

        const base64Data = croppedCanvas.toDataURL("image/jpeg", 0.8);

        try {
          const response = await uploadIDCardsImage(base64Data);
          if (response && response.location) {
            setStoryForm({
              ...storyForm,
              idCard: response.location,
            });
            // Show success message
            setSuccessMessage("ID Card uploaded successfully");
          } else {
            throw new Error("Upload failed");
          }
        } catch (error) {
          console.error("Error uploading ID card:", error);
          setError("Failed to upload ID card. Please try again.");
          setCloseError(false);
        }
      } catch (error) {
        console.error("Error processing ID card image:", error);
        setError("Failed to process ID card image. Please try again.");
        setCloseError(false);
      }
    }
  };
  const convertIdCardToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setIdCardBase64(reader.result);
    };
  };

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setBase64Image(reader.result);
      setImgData(reader.result);
    };
  };

  function updateLanguage(value) {
    setStoryForm({
      ...storyForm,
      languageId: value,
    });
  }
  function updateCityName(value) {
    setStoryForm({
      ...storyForm,
      cityName: value,
    });
  }
  function updateCollegeName(value) {
    setStoryForm({
      ...storyForm,
      collegeName: value,
    });
  }
  function updateCollegeAddress(value) {
    setStoryForm({
      ...storyForm,
      collegeAddress: value,
    });
  }
  function updateRefId(value) {
    setStoryForm({
      ...storyForm,
      refId: value,
    });
  }
  function updateCategory(id) {
    // e.preventDefault()
    if ($("#" + id).hasClass("active")) {
      val -= 1;
      $("#" + id).removeClass("active");
      $("#" + id + "_check").removeClass("icofont-plus");
      $("#" + id + "_check").addClass("icofont-check");
      var index = arr
        .map((x) => {
          return x;
        })
        .indexOf(id);
      arr.splice(index, 1);
    } else {
      val += 1;
      $("#" + id).addClass("active");
      $("#" + id + "_check").removeClass("icofont-check");
      $("#" + id + "_check").addClass("icofont-plus");
      arr.push(id);
    }

    setStoryForm({
      ...storyForm,
      categoryId: arr,
    });
  }

  async function getTHumbnail(page) {
    let token = localStorage.getItem("loginDetails");
    let response = await Axios.get(
      Constant.apiBasePath + "content-thumbnail/getDataForUser?pageNo=" + page,
      {
        headers: { token: token },
      }
    );
    console.log("asassaa", response.data);
    if (response.status !== "Success") {
      console.log("asassaa");
      setImages(response.data.data);
      setPageNo(response.data.pageNo);
      setLength(response.data.length);
    } else {
      setError(response.message);
      setCloseError(false);
    }
  }

  function setThumbnail(thumbnail, id) {
    setStoryForm({
      ...storyForm,
      thumbnail: thumbnail,
    });

    $(".ticcircle").removeClass("active");
    $("#ticcircle_" + id).addClass("active");
  }

  async function submitStory(e) {
    console.log("Logging story form", storyForm);
    e.preventDefault();
    // setIsSubmitting(true);
    setError("");

    try {
      // Clone form data
      if (contestdata._id === "679f053d53c06c95d82a88ca") {
        setStoryForm((prevForm) => ({
          ...prevForm,
          categoryId: ["65b657962e5c1ebb447265c6"],
        }));
      }
      let form = { ...storyForm };
      console.log(form);

      // Handle file uploads
      try {
        if (selectedFile) {
          await convertToBase64(selectedFile);
        }

        if (idCardSelectedFile) {
          await convertIdCardToBase64(idCardSelectedFile);
        }

        if (imgdata) {
          const response = await uploadThumbImage(imgdata);
          if (!response || !response.location) {
            throw new Error("Failed to upload thumbnail image");
          }
          form["thumbnail"] = response.location;
        }

        if (idCardBase64) {
          const idCardResponse = await uploadIDCardsImage(idCardBase64);
          if (!idCardResponse || !idCardResponse.location) {
            throw new Error("Failed to upload ID card image");
          }
          form["idCard"] = idCardResponse.location;
        }
      } catch (uploadError) {
        throw new Error(`File upload failed: ${uploadError.message}`);
      }

      // Validate form fields
      const validationChecks = [
        { condition: !form.name, message: "nameis not allowed to be empty" },
        {
          condition: !form.description,
          message: "description is not allowed to be empty",
        },
        {
          condition: !form.categoryId.length,
          message: "categoryId does not contain 1 required value(s)",
        },
        {
          condition: !form.duration,
          message: "duration is not allowed to be empty",
        },
        {
          condition: contestdata.refId && !form.refId,
          message: "Please upload your Payment reference id no.",
        },
        {
          condition: contestdata.refId && form.refId.length !== 12,
          message: "Incorrect upi refId",
        },
        {
          condition: contestdata.idCard && !form.idCard,
          message: "Please upload idCard image",
        },
        {
          condition: contestdata.cityName && !form.cityName,
          message: "Please enter your city name",
        },
        {
          condition: contestdata.collegeName && !form.collegeName,
          message: "Please enter your college name",
        },
        {
          condition: contestdata.collegeAddress && !form.collegeAddress,
          message: "Please enter your college address",
        },
        { condition: !form.languageId, message: "Please Select a language" },
      ];

      for (const check of validationChecks) {
        if (check.condition) {
          throw new Error(check.message);
        }
      }

      // Create story
      const response = await createStory(form);
      console.log(response);

      if (response.status === statusFailure || !response.data) {
        throw new Error(response.message || "Failed to create story");
      }

      // Handle successful story creation
      const token = localStorage.getItem("loginDetails");
      const userDetails = token ? getTokenDetails(token) : {};

      // Handle contest payment if needed
      if (storyForm.contestId && amount) {
        try {
          const paymentRequest = {
            amount: parseInt(amount),
            purpose: "Write story",
            redirectURL: `${Constant.domain}profile/${userDetails._id}`,
            isPrime: 1,
            paymentFor: 2,
            enrollmentId: response.data._id,
          };

          const orderResponse = await createPaymentRequest(paymentRequest);

          if (orderResponse.status !== Constant.statusSuccess) {
            throw new Error(orderResponse.message || "Payment request failed");
          }

          window.location.href = orderResponse.data.longurl;
        } catch (paymentError) {
          throw new Error(`Payment processing failed: ${paymentError.message}`);
        }
      } else {
        // Handle non-contest submission
        setSuccessMessage(response.message);
        setCloseSuccess(false);

        if (id && type && userDetails) {
          setTimeout(() => history.push(`/profile/${userDetails._id}`), 3000);
        } else if (response.isAccess === false) {
          setTimeout(() => history.push("/plans"), 3000);
        } else {
          setTimeout(() => history.push("/"), 3000);
        }
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      setError(errorMessage);
      setCloseError(false);
      setbtnStatus(false);
    }
  }

  function uploadDocuments(response) {
    response = JSON.parse(response);
    if (response.status !== statusFailure) {
      setStoryForm({
        ...storyForm,
        document: [...storyForm.document, response.location],
      });
    } else {
      setError(response.message);
      setCloseError(false);
    }
  }

  function previousPage(page) {
    setPageNo(page);
  }

  function nextPage(page) {
    setPageNo(page);
  }

  var previous = 0;
  var next = 0;
  var customLength = 0;

  if (pageNo >= 0) {
    previous = pageNo - 1;
    next = pageNo + 1;
  }

  if (length !== 0) {
    customLength = length;
  }

  function handleModel(type) {
    if (type === 1) {
      window.$("#contentThumbnail").modal("show");
    } else {
      window.$("#contentThumbnail").modal("hide");
    }
  }

  function uploadThumbnail() {
    document.getElementById("file-image").classList.remove("hidden");
    document.getElementById("file-image").src =
      "https://story-tent-testing.s3.ap-south-1.amazonaws.com/contest/image_1706224293881.jpg";
    window.$("#contentThumbnail").modal("hide");
  }

  if (contentData.name !== undefined) {
    document.getElementById("file-image").classList.remove("hidden");
    document.getElementById("file-image").src = contentData.thumbnail;
  }
  async function getAIgeneratedImage(e) {
    console.log(storyForm.name);
    console.log(storyForm.description);
    if (retry < 3) {
      e.preventDefault();
      setgenBtnStatus(true);
      var data = await getThumbnailsFromAI(
        storyForm.name
        // storyForm.description
      );
      setImgData(data[1]);
      setRetry(retry + 1);
      console.log(retry);
      document.getElementById("file-image").classList.remove("hidden");
      document.getElementById("file-image").src = data[0];
      e.preventDefault();
      setgenBtnStatus(false);
      setGetImage(true);
    } else {
      setError(
        "You have exceeded AI Thumbnail generation limit which is 3 images"
      );
      setCloseError(false);
    }
  }
  function validatePreviewData() {
    if (storyForm.name === "") {
      setbtnStatus(true);
      setError('"name" is not allowed to be empty');
      setCloseError(false);
    } else if (storyForm.thumbnail === "") {
      setbtnStatus(true);
      setError('"thumbnail" is not allowed to be empty');
      setCloseError(false);
      // storyForm.thumbnail= "https://story-tent-testing.s3.ap-south-1.amazonaws.com/contest/image_1706224293881.jpg"
    } else if (storyForm.categoryId.length < 1) {
      setbtnStatus(true);
      setError('"categoryId" does not contain 1 required value(s)');
      setCloseError(false);
    } else if (storyForm.duration === "") {
      setbtnStatus(true);
      setError('"duration" is not allowed to be empty');
      setCloseError(false);
    } else if (storyForm.languageId === "") {
      setbtnStatus(true);
      setError("Please Select a language");
      setCloseError(false);
    } else if (contestdata.refId && storyForm.refId === "") {
      setbtnStatus(true);
      setError("Please upload your UPI ID");
      setCloseError(false);
    } else if (contestdata.idCard && storyForm.idCard === "") {
      setbtnStatus(true);
      setError("Please upload idCard image");
      setCloseError(false);
    } else {
      setError("");
      setbtnStatus(false);
      $("#first-step").hide();
      $("#second-step").show();
    }
  }

  function hideStepTwo() {
    $("#second-step").hide();
    $("#first-step").show();
  }

  const getTitleText = () => {
    if (language === "Hindi") {
      return "कहानी का शीर्षक दर्ज करें";
    } else {
      return "Enter Story title";
    }
  };
  const getCategoryText = () => {
    if (language === "Category") {
      return "वर्ग";
    } else {
      return "Category";
    }
  };
  const getLanguageText = () => {
    if (language === "Language") {
      return "वर्ग";
    } else {
      return "Language";
    }
  };
  const getDurationText = () => {
    if (language === "Hindi") {
      return "अवधि";
    } else {
      return "Duration";
    }
  };
  const getWriteStoryText = () => {
    if (language === "Hindi") {
      return "कहानी लिखें";
    } else {
      return "Write Story";
    }
  };
  const getGenerateButtonText = () => {
    if (language === "Hindi") {
      return "AI के साथ जनरेट करें";
    } else {
      return "Generate With AI";
    }
  };

  const getSubmitButtonText = () => {
    if (language === "Hindi") {
      return "सबमिट करे ";
    } else {
      return "Submit ";
    }
  };
  const getUploadText = () => {
    if (language === "Hindi") {
      return "कहानी शीर्षक छवि अपलोड करें";
    } else {
      return "Upload Story Title Image";
    }
  };

  const switchLng = (lng) => {
    console.log(lng);
    i18next.changeLanguage(lng);
  };

  const handlelng = (event) => {
    const selectedLanguage = event.target.value;
    switchLng(selectedLanguage);
  };

  const responseGoogle = (credentialResponse) => {
    if (credentialResponse.credential) {
      console.log("Google login response:", credentialResponse);
      let tokenId = credentialResponse.credential;

      authGoogle({ token: tokenId })
        .then((response) => {
          console.log("Google Check", response);

          if (response.status !== statusFailure) {
            // Store the token properly
            localStorage.setItem("loginDetails", response.data.token);
            dispatch({ type: "login", payload: response.data.token });

            // Track the event
            if (response.message === "Account created successfully.") {
              ReactGA.event({
                category: "User",
                action: "Register Success",
                label: "Google Register Success",
              });
              console.log("Account created successfully");
            } else if (response.message === "User already exist") {
              ReactGA.event({
                category: "User",
                action: "Login Success",
                label: "Google Login Success",
              });
              console.log("Login successful");
            }

            // Refresh the page after successful login
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error("Google auth error:", error);
          localStorage.removeItem("loginDetails"); // Clear invalid token
        });
    }
  };

  // Add state for auth tracking
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  // Add auth check effect
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("loginDetails");
      setIsAuthenticated(!!token);
      setShowLoginPopup(!token);
    };

    // Initial check
    checkAuth();

    // Add event listeners for storage changes and logout
    window.addEventListener("storage", checkAuth);
    window.addEventListener("logout", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
      window.removeEventListener("logout", checkAuth);
    };
  }, []);

  return (
    <Layout>
      <div
        style={{
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          backgroundColor: "#0f1817",
          height: "auto",
        }}
      >
        <Root>
          {error && !closeError && (
            <div className="pop-up" style={{ zIndex: 99 }}>
              <div
                onClick={() => setCloseError(true)}
                style={{
                  position: "absolute",
                  color: "black",
                  top: "0px",
                  right: "0px",
                }}
              >
                <Plus className="cross"></Plus>
              </div>
              <div>
                {" "}
                <span
                  style={{
                    backgroundColor: "red",
                    padding: "2px",
                    borderRadius: "50px",
                  }}
                >
                  <Plus className="cross"></Plus>
                </span>{" "}
                {error}
              </div>
            </div>
          )}

          {successMessage && !CloseSuccess && (
            <div className="pop-up-success" style={{ zIndex: 99 }}>
              <div
                onClick={() => setCloseSuccess(true)}
                style={{
                  position: "absolute",
                  color: "white",
                  top: "0px",
                  right: "0px",
                }}
              >
                <Plus className="cross"></Plus>
              </div>{" "}
              <span
                style={{
                  backgroundColor: "green",
                  padding: "2px",
                  borderRadius: "50px",
                  marginRight: "10px",
                }}
              >
                <Check style={{ color: "white" }}></Check>
              </span>{" "}
              {successMessage}{" "}
            </div>
          )}

          <div className=" create-story-container ">
            <div className="input-container">
              <h1 className="label">{t("Write.writeStory.EnterTitle")}</h1>
              <input
                onChange={onFormChange}
                name="name"
                id="name"
                type="text"
                defaultValue={storyForm.name}
                required
                placeholder={t("Write.writeStory.innerTitle")}
                className="input"
              ></input>
            </div>

            {contestdata._id !== "679f053d53c06c95d82a88ca" && (
              <div className="input-container-select">
                <h1 className="label">
                  {t("Write.writeStory.Category.Category")}
                </h1>
                <select
                  onChange={(e) => {
                    updateCategory(e.target.value);
                  }}
                  name="category"
                  className="input-select"
                >
                  <option value="category" selected>
                    {" "}
                    {t("Write.writeStory.Category.Category")}
                  </option>
                  {categories &&
                    categories.length > 0 &&
                    categories.map((category, index) => {
                      return (
                        <option key={category._id} value={category._id}>
                          {" "}
                          {category.name}
                        </option>
                      );
                    })}
                </select>
              </div>
            )}

            <div className="input-container-duration">
              <h1 className="label">{t("Write.writeStory.Duration")}</h1>
              <input
                placeholder={t("Write.writeStory.innerDuration")}
                onChange={onFormChange}
                name="duration"
                type="Number"
                defaultValue={storyForm.duration}
                required
                className="input"
              ></input>
            </div>
            <div className="input-container-select-lang">
              <h1 className="label">
                {t("Write.WritePoem.Language.Language")}
              </h1>
              <select
                onChange={(e) => {
                  updateLanguage(e.target.value);
                }}
                name="languageId"
                className="input-select"
              >
                {languages &&
                  languages.length > 0 &&
                  languages.map((language, index) => {
                    return (
                      <option key={language.label} value={language._id}>
                        {language.label}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div
            className=" create-story-container "
            style={{ paddingTop: "20px" }}
          >
            {/* {contestdata.refId && (
              <div className="input-container-duration">
                <PayButton onClick={() => setPayOpen((prev) => !prev)}>
                  How to Pay
                </PayButton>
              </div>
            )} */}
            {payOpen && (
              <PayModalOverlay>
                <PayModalContainer>
                  <CloseButton onClick={() => setPayOpen(false)}>✕</CloseButton>
                  <h3> {t("Pay.HowToPay")}</h3>

                  <StepSection color="#e6f2ff">
                    <h4> {t("Pay.step1")}</h4>
                    <p> {t("Pay.step1Desc")}</p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        className="payqr"
                        src="https://story-tent-testing.s3.ap-south-1.amazonaws.com/contest-pay-qr.jpeg"
                        alt="Payment QR Code"
                      />
                    </div>
                  </StepSection>
                  <StepSection color="#e6f9f0">
                    <h4> {t("Pay.step2")}</h4>
                    <p>{t("Pay.step2Desc")}</p>
                  </StepSection>

                  <StepSection
                    color="#fff2f2"
                    style={{
                      borderColor: "red",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        marginBottom: "0px",
                        fontSize: "20px",
                        textAlign: "center",
                      }}
                    >
                      {t("Pay.disclaimer")}
                    </p>
                    <p style={{ marginBottom: "0px", textAlign: "center" }}>
                      {t("Pay.disc1")}
                    </p>
                    <p style={{ marginBottom: "0px", textAlign: "center" }}>
                      {t("Pay.disc2")}
                    </p>
                  </StepSection>
                </PayModalContainer>
              </PayModalOverlay>
            )}
            {contestdata.refId && (
              <div className="input-container-duration">
                <h1 className="label">
                  {t("Write.writeStory.UPI-Id")}-{" "}
                  <span
                    style={{
                      fontSize: "18px",
                      color: "red",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => setPayOpen((prev) => !prev)}
                  >
                    {t("Write.writeStory.HowtoPay")}
                  </span>
                </h1>
                <input
                  placeholder={t("Write.writeStory.Enter-your-upi-id")}
                  onChange={(e) => updateRefId(e.target.value)}
                  name="refId"
                  type="text"
                  defaultValue={storyForm.refId}
                  required
                  className="input"
                ></input>
              </div>
            )}
            {contestdata.cityName && (
              <div className="input-container-duration">
                <h1 className="label">{t("Write.writeStory.CityName")}</h1>
                <input
                  placeholder={t("Write.writeStory.EnterCityName")}
                  onChange={(e) => updateCityName(e.target.value)}
                  name="CityName"
                  type="text"
                  defaultValue={storyForm.cityName}
                  required
                  className="input"
                ></input>
              </div>
            )}
            {contestdata.collegeName && (
              <div className="input-container-duration">
                <h1 className="label">{t("Write.writeStory.CollegeName")}</h1>
                <input
                  placeholder={t("Write.writeStory.EnterCollegeName")}
                  onChange={(e) => updateCollegeName(e.target.value)}
                  name="collegeName"
                  type="text"
                  defaultValue={storyForm.collegeName}
                  required
                  className="input"
                ></input>
              </div>
            )}
            {contestdata.collegeAddress && (
              <div className="input-container-duration">
                <h1 className="label">
                  {t("Write.writeStory.CollegeAddress")}
                </h1>
                <input
                  placeholder={t("Write.writeStory.EnterCollegeAddress")}
                  onChange={(e) => updateCollegeAddress(e.target.value)}
                  name="collegeAddress"
                  type="text"
                  defaultValue={storyForm.collegeAddress}
                  required
                  className="input"
                ></input>
              </div>
            )}
          </div>
          <div className="story-write-container">
            <div className="input-container-story-write">
              <h1 style={{ color: "gray" }}>
                {t("Write.writeStory.WriteStory")}
              </h1>
              <textarea
                rows={20}
                type="text"
                className="story-writing-area"
                placeholder={t("Write.writeStory.innerWriteStory")}
                onChange={onFormChange}
                name="description"
                id="description"
                defaultValue={storyForm.description}
              />
            </div>
            {contestdata.idCard && (
              <div className="uploader-outer-container">
                <div className="uploader-container">
                  <form id="idcard-upload-form" className="uploader">
                    <input
                      id="idcard-upload"
                      type="file"
                      accept="image/*"
                      onChange={handleIdCardFileChange}
                      name="idCard"
                      style={{ display: "none" }}
                    />

                    {idCardImage ? (
                      // When image exists, don't wrap in clickable label
                      <div
                        id="idcard-image-container"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Cropper
                          style={{
                            height: 200,
                            width: "100%",
                            marginBottom: "10px",
                          }}
                          zoomTo={0.5}
                          initialAspectRatio={1}
                          preview=".img-preview"
                          src={idCardImage}
                          viewMode={1}
                          minCropBoxHeight={10}
                          minCropBoxWidth={10}
                          background={false}
                          responsive={true}
                          autoCropArea={1}
                          checkOrientation={false}
                          onInitialized={(instance) => {
                            setIdCardCropper(instance);
                          }}
                          guides={true}
                        />
                      </div>
                    ) : (
                      // Only use the clickable label when no image is uploaded yet
                      <label
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        htmlFor="idcard-upload"
                        id="idcard-drag"
                      >
                        <div id="idcard-image-container">
                          {/* This container will be empty when no image is selected */}
                        </div>

                        <div id="idcard-text-container">
                          <div
                            id="idcard-start"
                            className={idCardBase64 ? "hidden" : ""}
                          >
                            <i
                              className="fa fa-download"
                              aria-hidden="true"
                            ></i>
                            <div>
                              <div style={{ color: "white", fontSize: "15px" }}>
                                {t("Write.writeStory.uploadIdCard")}
                              </div>
                            </div>
                            <div id="idcard-notimage" className="hidden">
                              {t("Write.writeStory.SelectedIdCard")}
                            </div>
                          </div>
                        </div>
                      </label>
                    )}
                  </form>
                </div>

                {/* Add ID card cropper buttons if needed */}
                {idCardImage && (
                  <div
                    className="cropper-buttons"
                    style={{
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={getIdCardCropData}
                      className="button"
                      style={{ marginBottom: "10px" }}
                    >
                      {t("Write.writeStory.CropImage")}
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("idcard-upload").click()
                      }
                      className="button"
                    >
                      Upload ID
                    </button>
                  </div>
                )}

                {/* <div className="uploader-buttons">
                  <button
                    type="button"
                    onClick={() =>
                      document.getElementById("idcard-upload").click()
                    }
                    className="button"
                  >
                    <span>{t("choose ID Card image")}</span>
                  </button>
                </div> */}
              </div>
            )}
            <div className="uploader-outer-container">
              <div className="uploader-container">
                <form id="file-upload-form" className="uploader">
                  <input
                    id="file-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    name="thumbnail"
                    style={{ display: "none" }}
                  />

                  {image ? (
                    <div id="image-container">
                      <Cropper
                        style={{
                          height: 200,
                          width: "100%",
                          marginBottom: "10px",
                        }}
                        zoomTo={0.5}
                        initialAspectRatio={1}
                        preview=".img-preview"
                        src={image}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false}
                        onInitialized={(instance) => {
                          setCropper(instance);
                        }}
                        guides={true}
                      />
                    </div>
                  ) : (
                    <label htmlFor="file-upload" id="file-drag">
                      <div id="image-container">
                        <img
                          id="file-image"
                          src={base64Image || "/images/download-image.png"}
                          alt="Preview"
                          className={base64Image ? "" : "hidden"}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                            display: "block",
                          }}
                        />
                      </div>
                      <div id="text-container">
                        <div id="start" className={base64Image ? "hidden" : ""}>
                          <i className="fa fa-download" aria-hidden="true"></i>
                          <div>
                            <div style={{ color: "white", fontSize: "15px" }}>
                              {t("Write.writeStory.selectedImage")}
                            </div>
                          </div>
                          <div id="notimage" className="hidden">
                            Please select an image
                          </div>
                        </div>
                      </div>
                      <div id="response" className="hidden">
                        <div id="messages"></div>
                        <progress
                          className="progress"
                          id="file-progress"
                          value="0"
                        >
                          <span>100%</span>%
                        </progress>
                      </div>
                    </label>
                  )}
                </form>
              </div>

              {image && (
                <div
                  className="cropper-buttons"
                  style={{ marginBottom: "10px", marginTop: "10px" }}
                >
                  <button
                    type="button"
                    onClick={getCropData}
                    className="button"
                  >
                    {t("Write.writeStory.CropImage")}
                  </button>
                </div>
              )}

              <div className="uploader-buttons">
                <button
                  type="button"
                  onClick={() => document.getElementById("file-upload").click()}
                  className="button"
                >
                  <span>{t("Write.writeStory.ChooseImage")}</span>
                </button>
                <button
                  type="button"
                  onClick={submitStory}
                  disabled={btnStatus}
                  className="button"
                >
                  {btnStatus ? (
                    <Loader2 className="loader"></Loader2>
                  ) : (
                    <span>{t("Write.writeStory.Button2")}</span>
                  )}
                </button>
              </div>
            </div>
            {/* idcard image upload  */}
          </div>
        </Root>
      </div>
      {showLoginPopup && (
        <PopupOverlay>
          <PopupContent>
            <img
              className="img"
              height={"80px"}
              width={"80px"}
              src={Logo}
              alt="logo"
            />
            <center>
              <p className="event-p3">{t("Login.Welcome")}</p>
            </center>
            <div className="login-container">
              <GoogleOAuthProvider clientId="451080537233-a0gdg7j86p0valvd0vbs161ebeqgq0lt.apps.googleusercontent.com">
                <GoogleLogin
                  onSuccess={responseGoogle}
                  onError={() => {
                    console.error("Google Login Failed");
                  }}
                  useOneTap={false}
                  ux_mode="popup"
                  type="standard"
                  theme="filled_black"
                  text="continue_with"
                  shape="rectangular"
                  locale="en"
                />
              </GoogleOAuthProvider>
            </div>

            <CustomLanguageDropdown onChange={handlelng} />

            <div style={{ textAlign: "center", marginTop: "30px" }}>
              <p style={{ color: "white" }}>
                By continuing, you agree to our <br />
                <Link to="/term-condition" className="text-blue underline mx-1">
                  terms and conditions
                </Link>
                and
                <Link to="/privacy-policy" className="text-blue underline mx-1">
                  privacy policy
                </Link>
                .
              </p>
            </div>
          </PopupContent>
        </PopupOverlay>
      )}
    </Layout>
  );
}

export default StoryWrite;

const PayModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .payqr {
    width: 200px;
    height: 250px;
  }
`;

const PayModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  position: relative;

  @media (max-width: 600px) {
    padding: 12px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
`;

const PayButton = styled.button`
  font-size: 20px;
  background-color: white;
  color: black;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const StepSection = styled.div`
  background-color: ${(props) => props.color || "#f0f0f0"};
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 15px;
`;

const Root = styled.div`
  min-height: 100vh;
  max-width: 1300px;
  height: auto;
  width: 100%;
  background-color: #0f1817;
  padding-top: 20px;
  align-items: center;
  display: flex;
  flex-direction: column;

  .PayButton {
    font-size: 20px;
  }

  .PayContainer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: "#cccccc";
  }
  .paypopup {
    width: 500px;
    height: 200px;
    background-color: white;
    border-radius: 10px;
    position: fixed;
    padding: 10px;
  }
  .uploader-buttons {
    margin-top: 10px;
    gap: 10px;
    justify-content: center;
    align-items: center;
    display: flex;
    margin-bottom: 20px;
  }
  .loader {
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .pop-up-success {
    width: 80%;
    min-width: 300px;
    padding-left: 10px;
    padding-right: 10px;
    width: auto;
    min-height: 40px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: auto;
    color: white;
    background-color: #263a38;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-left: 3px solid green; /* Add red border at the bottom */
  }

  .pop-up {
    width: 100%;
    min-width: 300px;
    padding-left: 10px;
    padding-right: 30px;
    width: auto;
    min-height: 40px;
    height: auto;
    color: white;
    background-color: #263a38;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-left: 3px solid red; /* Add red border at the bottom */
  }

  .cross {
    transform: rotate(45deg);
    color: white;
  }

  .button {
    border: none;
    outline: none;
    padding: 5px;
    background-color: #c81919;
    color: white;
    border-radius: 20px;
    width: 175px;
  }

  .uploader-outer-container {
    width: 30%;
    max-width: 350px;
    @media (min-width: 350px) and (max-width: 900px) {
      width: 80%;
      min-width: 300px;
      margin-top: 20px;
    }
  }

  .create-story-container {
    width: 90%;
    display: flex;
    gap: 20px;
    @media (min-width: 350px) and (max-width: 900px) {
      flex-direction: column;
      gap: 20px;
      width: 80%;
    }
  }

  .input-container-story-write {
    width: 70%;
    @media (min-width: 350px) and (max-width: 900px) {
      width: 100%;
    }
  }

  .uploader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .story-writing-area {
    width: 100%;
    background-color: #0c343a;
    border-radius: 10px;
    outline: none;
    border: none;
    padding-left: 20px;
    color: white;
  }

  .story-write-container {
    margin-top: 20px;
    width: 90%;
    gap: 20px;
    display: flex;
    @media (min-width: 350px) and (max-width: 900px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 80%;
    }
  }

  .uploader-container {
    width: 100%;
    max-width: 350px;
    border: 2px dashed #52b2cf;
    height: 420px;
    border-radius: 10px;
    margin-top: 60px;
    @media (min-width: 350px) and (max-width: 900px) {
      width: 100%;
      ${
        "" /* min-width:300px;
       margin-top:50px; */
      }
    }
  }

  .input-container {
    width: 50%;

    @media (min-width: 350px) and (max-width: 900px) {
      width: 100%;
    }
  }

  .uploader-container {
  }

  .input-container-duration {
    width: 25%;
    @media (min-width: 350px) and (max-width: 900px) {
      width: 100%;
    }
  }

  .input-container-select {
    width: 25%;
    @media (min-width: 350px) and (max-width: 900px) {
      width: 100%;
    }
  }

  .input-container-select-lang {
    width: 10%;
    @media (min-width: 350px) and (max-width: 900px) {
      width: 100%;
    }
  }

  .label {
    font-size: 20px;
    color: gray;
  }

  .input-select {
    width: 100%;
    border-radius: 20px;
    background-color: #0c343a;
    color: white;
    outline: none;
    padding-right: 20px;
    border: none;
    padding: 7px;
    padding-left: 10px;
  }

  .input {
    color: white;
    background-color: #0c343a;
    width: 100%;
    ${"" /* max-width:400px; */}
    border-radius:20px;
    outline: none;
    border: none;
    padding: 5px;
    padding-left: 10px;
    display: block;
  }
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const PopupContent = styled.div`
  background-color: #0f1817;
  padding: 20px;
  border-radius: 14px;
  width: 90%;
  height: auto;
  max-width: 430px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h2 {
    color: white;
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
  }

  .login-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
`;
